exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".JbjXG{width:340px;height:300px;background:#fff;border-radius:5px;padding:15px;-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:30px}._29SwS,.JbjXG{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal}._29SwS{-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row;margin-bottom:20px}.YiIiW{width:50px;height:50px;margin-right:10px;border-radius:50px}._3H-Rq{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.nCIpd{font-size:14px;line-height:140%;margin-bottom:20px}._1nDMy{height:0;border-bottom:1px solid #c4c4c4;margin-bottom:15px}", ""]);

// exports
exports.locals = {
	"root": "JbjXG",
	"head": "_29SwS",
	"avatar": "YiIiW",
	"name": "_3H-Rq",
	"text": "nCIpd",
	"divider": "_1nDMy"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/Article/Leasing/LeasingFeedback/LeasingFeedbackCard/LeasingFeedbackCard.css
// module id = 3237
// module chunks = 21